import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_entity_import_requestsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { requestIds?: string[], statuses_to_include?: string[], statuses_to_ignore?: string[] }): 
  Promise<{ result: { RequestId?: string, ErrorMessage?: string, StatusCode?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_entity_import_requests/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { requestIds?: string[], statuses_to_include?: string[], statuses_to_ignore?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { RequestId?: string, ErrorMessage?: string, StatusCode?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_entity_import_requests/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { requestIds?: string[], statuses_to_include?: string[], statuses_to_ignore?: string[], $keys: string[] }): 
  Promise<{ result: { RequestId?: string, ErrorMessage?: string, StatusCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_entity_import_requests/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

